import { render, staticRenderFns } from "./OperativeRegisterWidget.vue?vue&type=template&id=2da35a30&scoped=true&"
import script from "./OperativeRegisterWidget.vue?vue&type=script&lang=js&"
export * from "./OperativeRegisterWidget.vue?vue&type=script&lang=js&"
import style0 from "./OperativeRegisterWidget.vue?vue&type=style&index=0&id=2da35a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da35a30",
  null
  
)

export default component.exports